import { hot } from "react-hot-loader";

import React from "react";
import { number, oneOfType, string } from "prop-types";

import EditListingLink from "../EditListingLink";
import { ManageShowingsLink } from "../ManageShowingsLink";
import * as S from "./styled";

const AgentToolsActions = ({ editListingUrl, listingId, listingType }) => (
  <S.List>
    {listingType === "Sale" && (
      <S.ListItem>
        <ManageShowingsLink saleId={listingId} />
      </S.ListItem>
    )}
    <S.ListItem>
      <EditListingLink editListingUrl={editListingUrl} listingId={listingId} />
    </S.ListItem>
  </S.List>
);

AgentToolsActions.propTypes = {
  editListingUrl: string.isRequired,
  listingId: oneOfType([number, string]).isRequired,
  listingType: string.isRequired
};

export default hot(module)(AgentToolsActions);
